import ProjectItem from './ProjectItem';
import ProjectsList from './ProjectsList';

export {
  ProjectsList,
  ProjectItem,
};



// WEBPACK FOOTER //
// ./src/components/Projects/index.js